import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BaseSectionComponent } from 'app/shared/base-classes/sections/base-section.component';
import { SingleDropdownComponent } from 'app/shared/components/dropdowns/single-dropdown/single-dropdown.component';
import { InputFieldComponent } from 'app/shared/components/input-field/input-field.component';
import { numberCast } from 'app/shared/functions/sectionCasters.function';
import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { VehicleRecordModel } from '../../../models/vehicle-record.model';
import {
	VEHICLE_ENGINE_SIZE_UNIT,
	VEHICLE_FUEL_TANK_CAPACITY,
} from '../../../translations/vehicles-select-items';
import { ToggleNewComponent } from 'app/shared/components/toggle-new/toggle-new.component';

@Component({
	selector: 'app-vehicles-engine',
	templateUrl: 'vehicles-engine.component.html',
	imports: [
		ReactiveFormsModule,
		SingleDropdownComponent,
		InputFieldComponent,
		SectionWrapperComponent,
		ToggleNewComponent,
	],
})
export class VehiclesEngineComponent extends BaseSectionComponent<VehicleRecordModel> {
	protected _skipCount: number = 0;

	engineSizeUnit = VEHICLE_ENGINE_SIZE_UNIT;
	fuelTankCapacityUnit = VEHICLE_FUEL_TANK_CAPACITY;
	public engineTurbine: boolean;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			engineSizeUnit: [null],
			engineSize: [null],
			fuelTankCapacityUnit: [null],
			fuelTankCapacity: [null],
			engineOutput: [null],
			engineTurbine: [null],
		});
	}

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			engineSizeUnit: this.recordData().engineSizeUnit,
			engineSize: this.recordData().engineSize,
			fuelTankCapacityUnit: this.recordData().fuelTankCapacityUnit,
			fuelTankCapacity: this.recordData().fuelTankCapacity,
			engineOutput: this.recordData().engineOutput,
			engineTurbine: this.recordData().engineTurbine,
		};
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}

	protected _mapFormToModel(): Partial<VehicleRecordModel> {
		// the logic is to bypass the mysterious emission of "on" as a string from the checkbox
		if (
			this.detailsForm.controls.engineTurbine.value === true ||
			this.detailsForm.controls.engineTurbine.value === false
		) {
			this.engineTurbine = this.detailsForm.controls.engineTurbine.value;
		}
		return {
			engineSizeUnit: this.detailsForm.value.engineSizeUnit,
			engineSize: numberCast(this.detailsForm.value.engineSize),
			fuelTankCapacityUnit: this.detailsForm.value.fuelTankCapacityUnit,
			fuelTankCapacity: numberCast(this.detailsForm.value.fuelTankCapacity),
			engineOutput: numberCast(this.detailsForm.value.engineOutput),
			engineTurbine: this.engineTurbine,
		};
	}
}
